export const LS_SOUND_KEY = "sound-enabled";
export const LS_NEWS_KEY = "news-reviewed";
export const LS_SENSITIVE_DATA = "sensitive-data-hidden";
